// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:ix-R3x */\n._SdYf{grid-gap:var(--audio-spacing-16);display:grid;gap:var(--audio-spacing-16);grid-template-columns:1fr}.YYzR2{font-size:var(--audio-font-size-17);font-weight:600;line-height:var(--audio-line-height-24);margin:0;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": "_SdYf",
	"heading": "YYzR2"
};
export default ___CSS_LOADER_EXPORT___;
